// extracted by mini-css-extract-plugin
export default {"center":"Home_center__D2ZqH","ionCard":"Home_ionCard__RGRvg","Row":"Home_Row__HSK18"};